import { ActivatedRoute } from "@angular/router";
var CharacterComponent = (function () {
    function CharacterComponent(route) {
        this.route = route;
        this.title = 'test app';
    }
    CharacterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.surveyMetaId = params['surveyMetaId'];
            _this.learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
            _this.method = params['method'];
            if (_this.method == 1) {
                _this.learningPathId = _this.learningPathOrLearningTourId;
                _this.learningTourId = 'not';
            }
            else if (_this.method == 2) {
                _this.learningTourId = _this.learningPathOrLearningTourId;
                _this.learningPathId = 'not';
            }
        });
        jQuery.getScript("/assets/js/echarts.min.js", function (data, status, jqxhr) {
        });
    };
    return CharacterComponent;
}());
export { CharacterComponent };



// WEBPACK FOOTER //
// ./src/app/character.component.ts.pre-build-optimizer.js